import React from 'react'

import clsx from 'clsx'

import Stars from 'components/Stars'
import Typography from 'components/Typography'

import RatingNum from './components/RatingNum'
import ReviewsNum from './components/ReviewsNum'

import classes from './Rating.module.scss'

/** @type {import("./types").default} */
const Rating = ({
  className,
  rating,
  withRatingNum,
  withUp,
  reviewsNum,
  href = '',
  xs,
  onReviewsNumberClick = () => {},
}) => {
  return (
    <div
      className={clsx('Rating', classes.root, className, {
        [classes.xs]: xs,
        [classes.withUpContainer]: withUp,
      })}
    >
      {withRatingNum && <RatingNum rating={rating} xs={xs} />}
      <Stars rating={rating} size="16" />
      {(reviewsNum || reviewsNum === 0) && (
        <ReviewsNum href={href} reviewsNum={reviewsNum} xs={xs} onClick={onReviewsNumberClick} />
      )}
      {withUp && (
        <Typography className={classes.textUp} variant="tight-sm">
          & up
        </Typography>
      )}
    </div>
  )
}

export default Rating
